/*
 * Login view
 */

define(["marionette", "modules/login/template/loginTemplate.html"], function (
  Marionette,
  LoginTemplate,
) {
  var LoginView = {};
  var INPUT_ELEMENTS = ["inputUser", "inputPassword", "btnLogin"];

  LoginView.loginView = Marionette.ItemView.extend({
    template: LoginTemplate,
    triggers: {
      "submit form": "login",
    },
    modelEvents: {
      change: "render",
    },
    events: {
      "keypress #inputPassword": function (e) {
        var s = String.fromCharCode(e.which);
        if (s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey) {
          this.$el.find("#capsLock").removeClass("hidden");
        } else {
          this.$el.find("#capsLock").addClass("hidden");
        }
      },
    },
    beginLogin: function () {
      for (var i = 0, len = INPUT_ELEMENTS.length; i < len; ++i) {
        var el = this.$el.find("#" + INPUT_ELEMENTS[i]);
        el.prop("disabled", true);
      }
    },
    endLogin: function () {
      for (var i = 0, len = INPUT_ELEMENTS.length; i < len; ++i) {
        var el = this.$el.find("#" + INPUT_ELEMENTS[i]);
        el.prop("disabled", false);
      }
    },
  });

  return LoginView;
});
